export const SET_ORG_TYPE = 'SET_ORG_TYPE';
export const SET_USER_TYPE = 'SET_USER_TYPE';
export const RESET_ORG_TYPE = 'RESET_ORG_TYPE';
export const RESET_USER_TYPE = 'RESET_USER_TYPE';
export const SET_ROUTE_LIST = 'SET_ROUTE_LIST';
export const SET_USER_TYPES = 'SET_USER_TYPES';
export const SET_ORG_TYPES = 'SET_ORG_TYPES';
